import Image from 'next/image'
import { useLocale, useTranslations } from 'next-intl'
import { parseRegionFromLocale } from '@/setup/locales'
import { cn } from '@/utils/styles/cn'
import { CustomDeeplinkProps } from '@/utils/url/deeplinks'

interface IAppStoreDownloadButtonProps extends CustomDeeplinkProps {
    className?: string
    containerClassName?: string
    hideRating?: boolean
}

export const AppStoreDownloadButton = ({
    className,
    containerClassName,
    customDeeplink,
    hideRating,
}: IAppStoreDownloadButtonProps) => {
    const t = useTranslations()
    const locale = useLocale()

    const currentRegion = parseRegionFromLocale(locale).toLowerCase()

    return (
        <div className={cn('flex flex-col items-center gap-y-2 w-fit', containerClassName)}>
            <a
                href={customDeeplink || t('shared.appStoreDownloadUrl', { region: currentRegion })}
                target="_blank"
                hrefLang={locale}
                // Needed for Google Tag Manager
                className="app-download-button"
                rel="noreferrer"
            >
                <Image
                    src="/_images/meta/download-on-the-app-store.png"
                    alt="Download on the App Store"
                    width={192}
                    height={64}
                    style={{ aspectRatio: 3 / 1 }}
                    className={cn(className)}
                />
            </a>

            {!hideRating && (
                <div className="flex flew-row items-center">
                    <span className="font-semibold">⭐️ 4,8</span>
                    <span className="ml-1 font-normal text-black/80">(8606)</span>
                </div>
            )}
        </div>
    )
}
